// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"80":"16a6c3","211":"5ed79f","288":"1ef519","337":"4409ed","429":"6b2134","598":"cb36b0","635":"5d63ab","681":"2ef00e","682":"b64446","739":"7d6e0b","810":"cb36b0","818":"9768da","858":"cb36b0","936":"ce131b"}[chunkId] + ".min.css";
};